import { render, staticRenderFns } from "./building.vue?vue&type=template&id=9e1d9280&scoped=true"
import script from "./building.vue?vue&type=script&lang=ts"
export * from "./building.vue?vue&type=script&lang=ts"
import style0 from "./building.vue?vue&type=style&index=0&id=9e1d9280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1d9280",
  null
  
)

export default component.exports